import { apiClient } from './api';
import { ApiResponse, UserPreferences } from '../types';

export const userPreferencesService = {
  getPreferences: async (): Promise<UserPreferences> => {
    const response = await apiClient.get<ApiResponse<UserPreferences>>('/users/preferences');
    return response.data;
  },

  updatePreferences: async (preferences: Partial<UserPreferences>): Promise<UserPreferences> => {
    const response = await apiClient.put<ApiResponse<UserPreferences>>(
      '/users/preferences',
      preferences,
    );
    return response.data;
  },

  getFavorites: async (): Promise<any[]> => {
    const response = await apiClient.get<ApiResponse<any[]>>('/users/favorites');
    return response.data;
  },

  addFavorite: async (entityType: string, entityId: number | string): Promise<void> => {
    await apiClient.post('/users/favorites', { entity_type: entityType, entity_id: entityId });
  },

  removeFavorite: async (entityType: string, entityId: number | string): Promise<void> => {
    await apiClient.delete(`/users/favorites/${entityType}/${entityId}`);
  },

  getRecents: async (): Promise<any[]> => {
    const response = await apiClient.get<ApiResponse<any[]>>('/users/recents');
    return response.data;
  },
};
